import { colors } from '@kmns-internal/furikake'
import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import { ExcelConversionLogStatusEnum } from '@ulysses-inc/harami_api_client'

export const getStatusBadge = (status: number | undefined) => {
  if (status === ExcelConversionLogStatusEnum.SUCCESS) {
    return (
      <Stack direction="row" spacing={0.5} alignItems="center">
        <CheckCircleOutline sx={{ color: colors.success.main, fontSize: 24 }} />
        <Typography
          variant="body2"
          fontWeight="bold"
          color={colors.success.main}
        >
          成功
        </Typography>
      </Stack>
    )
  } else {
    return (
      <Stack direction="row" spacing={0.5} alignItems="center">
        <ErrorOutline sx={{ color: colors.error.main, fontSize: 24 }} />
        <Typography variant="body2" fontWeight="bold" color={colors.error.main}>
          失敗
        </Typography>
      </Stack>
    )
  }
}
